jQuery(document).ready(function($) {

   /*-- Open Menu --*/

   var menuButton = $('#m-header__button');
   var menuClose = $('.m-header__menu__close');
   var menu = $('#m-header__menu');

   menuButton.on('click',function() {
      if(menu.hasClass('m-header__menu--open')) {
         menu.removeClass('m-header__menu--open');
      } else {
         menu.addClass('m-header__menu--open');
      }
   })

   menuClose.on('click',function() {

      if( menu.hasClass('m-header__menu--open') ) {
         menu.removeClass('m-header__menu--open');
     
      }
   });

   if (window.innerWidth < 1025) {
      lastScrollTop = 0;
      $(window).scroll(function (event) {
         var st = $(this).scrollTop();
         if (st > lastScrollTop && st > 0) {
            $('.m-header').addClass('remove');
         } else {
            $('.m-header').removeClass('remove');
         }
      
         if (st > 0) {
            $('.m-header').addClass('background');
         } else {
            $('.m-header').removeClass('background');
         }
         lastScrollTop = st;
      
      });
   }

   $(".m-header__menu__list li a").click(function(e) { 
      menu.removeClass('m-header__menu--open');
      goToByScroll($(this).attr("href").replace("#", ""));  
   });
   
   function goToByScroll(id){
      $('html,body').animate({
         scrollTop: $("#" + id).offset().top
      },
            'slow');
   }

   

});
